import React, { FC } from 'react';
import { FieldValueProps } from './types';
import { Box, Text } from '@bechtel/gds';
import { TextWithEllipsis, EllipsisPlacement } from '~/components/atoms/text-with-ellipsis';

export const FieldValue: FC<FieldValueProps> = ({ field, value }) => {
  return (
    <Box>
      <Text size={'300'} weight={'600'} family="graphik" color="grey.1000">
        {field}:&nbsp;
      </Text>
      {value && (
        <TextWithEllipsis
          style={{
            lineHeight: 'unset !important' /*textwithellipses internally apply line-height */,
          }}
          size={'300'}
          family="graphik"
          color="grey.1000"
          ellipsisPlacement={EllipsisPlacement.END}
        >
          {value}
        </TextWithEllipsis>
      )}
    </Box>
  );
};
